module.exports = __webpack_public_path__ + "img/pasxa310x588.94efdf7f.jpg";